function applyStylesToIframe(iframe: any) {
  if (iframe.contentDocument) {
    const mainElement = iframe.contentDocument.querySelector('.main')
    const bannerElement = iframe.contentDocument.querySelector('.banner')
    if (mainElement) {
      const iframeStyle = iframe.contentDocument.createElement('style')
      iframeStyle.textContent = `
        .main {
          border-radius: 15px;
          border-color: #f6f6f6;
        }
      `
      iframe.contentDocument.head.appendChild(iframeStyle)
    }
    if (bannerElement) {
      const iframeStyle = iframe.contentDocument.createElement('style')
      iframeStyle.textContent = `
        .banner {
          border-radius: 15px;
          border-color: #f6f6f6;
        }
      `
      iframe.contentDocument.head.appendChild(iframeStyle)
    }
  }
}

export default function checkIframes() {
  const iframes = document.querySelectorAll('iframe')
  iframes.forEach((iframe) => {
    if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
      applyStylesToIframe(iframe)
    } else {
      iframe.addEventListener('load', () => {
        applyStylesToIframe(iframe)
      })
    }
  })
}
